/* eslint-disable dot-notation */
import { Button, Typography } from 'design_system/src';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ReactComponent as Back } from 'design_system/src/static/icons/back.svg';
import { ReactComponent as Edit } from 'design_system/src/static/icons/edit-text.svg';

import { Grid } from '@mui/material';
import profileDefaultOzonio from 'static/images/ozonio_default.png';
import Swal from 'sweetalert2';

import LoadDocuments from 'components/hocs/loadDocuments/loadDocuments';
import { RequireRole } from 'components/layouts/main/sidebar/Sidebar';
import {
	deleteFileOzonio,
	findOzonioById,
	restorePassword,
	updateImageOzonio,
	updateOzonio,
	uploadFileOzonio,
} from 'models/ozonio/controllers/ozonios.controller';
import {
	OzonioDocumentType,
	OzonioDocumentTypeValues,
	Roles,
} from 'models/ozonio/enums/ozonio.enum';
import { toasterOptions } from 'models/shared/enums/toaster.enum';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { EvidenceDocument } from 'models/shared/types/documents';
import EditOzonio from './EditOzonio';

function DetailsOzonio() {
	const [ozonio, setOzonio] = useState<any | null>();
	const [loading, setloading] = useState<boolean>(false);
	const [open, setOpen] = useState(false);
	const [result, setResult] = useState<any>();
	const [loadingActive, setLoadingActive] = useState(false);
	const navigate = useNavigate();
	const { _id } = useParams();

	const fetchOzonio = () => {
		if (_id) {
			setloading(true);
			findOzonioById(_id)
				.then((vehi: any) => {
					setloading(false);
					setOzonio(vehi);
				})
				.catch(() => {
					setloading(false);
					Swal.fire({
						title: 'Error!',
						text: 'ozonio no valido',
						icon: 'error',
						confirmButtonText: 'Aceptar',
					}).then(() => {
						navigate('/ozonio');
					});
				});
		}
	};

	useEffect(() => {
		fetchOzonio();
	}, []);

	useEffect(() => {
		setOzonio(result);
	}, [result]);

	const formatName = (name: string) => name.replaceAll(' ', '_');

	const handleFile = (e: any) => {
		const file = e.target.files[0];
		if (file.size > 10000000) {
			Swal.fire({
				text: 'La imagen no debe ser superior a 10mb',
				icon: 'warning',
				confirmButtonText: 'Aceptar',
			});
		} else {
			const blob = file.slice(0, file.size, file.type);
			const newFile = new File([blob], formatName(file.name), {
				type: file.type,
			});
			updateImageOzonio(ozonio['_id'], newFile).then((newData: any) => {
				setOzonio(newData);
			});
		}
	};

	const toogleActiveStatus = () => {
		if (_id) {
			setLoadingActive(true);
			updateOzonio({ isActive: !ozonio.isActive }, _id)
				.then(() => {
					setLoadingActive(false);
					fetchOzonio();
					toasterNotification({
						// eslint-disable-next-line no-nested-ternary
						msg: 'Usuario modificado exitosamente',
						toasterType: toasterOptions.success,
						style: 'light',
					});
				})
				.catch((err) => {
					setLoadingActive(false);
					toasterNotification({
						// eslint-disable-next-line no-nested-ternary
						msg: err ? (Array.isArray(err) ? err[0] : err) : 'Ocurrio un error',
						toasterType: toasterOptions.error,
						style: 'light',
					});
				});
		}
	};

	const handleDocument = (e: any, fileType: OzonioDocumentType) => {
		const file = e.target.files[0];
		if (file.size > 10000000) {
			Swal.fire({
				text: 'El archivo no debe pesar mas de 10mb',
				icon: 'warning',
				confirmButtonText: 'Aceptar',
			});
		} else if (ozonio) {
			const blob = file.slice(0, file.size, file.type);
			const newFile = new File([blob], formatName(file.name), {
				type: file.type,
			});
			uploadFileOzonio(ozonio._id, newFile, fileType)
				.then((newData) => {
					setOzonio({ ...ozonio, documents: newData.documents });
					toasterNotification({
						msg: 'Documento cargado satisfactoriamente',
						style: 'light',
						toasterType: toasterOptions.success,
					});
				})
				.catch(commonErrorHandler);
		}
	};

	const deleteFiles = (file: { _id: string; typeEvidence: string }) => {
		if (ozonio) {
			deleteFileOzonio(ozonio._id, file._id)
				.then((newData) => {
					setOzonio({ ...ozonio, documents: newData.documents });
					toasterNotification({
						msg: 'Documento eliminado satisfactoriamente',
						style: 'light',
						toasterType: toasterOptions.success,
					});
				})
				.catch(commonErrorHandler);
		}
	};

	return (
		<div>
			{!loading && ozonio ? (
				<div className="dim_100_per">
					<div className="display_flex flex_align_center m_b_lg">
						<Button
							variant="icon"
							icon={<Back />}
							subvariant="edit"
							scale="small"
							onClick={() => navigate(-1)}
						/>
						<Typography
							scale="heading1"
							weight="600"
							className="m_l_md text_neutral_900"
						>
							{ozonio.name}
						</Typography>
					</div>

					<Grid
						container
						direction="row"
						spacing={3}
						className="h_100_per p_t_md"
					>
						<Grid item xs={3} className="display_flex flex_col">
							<div className="flex_grow_1 dso_card bg_neutral_0 m_b_lg p_md flex_center_col_x">
								<Typography
									scale="heading4"
									weight="600"
									className="text_neutral_900 text_center m_b_xl"
								>
									{ozonio.name}
								</Typography>

								<div
									className="dso_card_img m_y_md w_fit center_x bg_neutral_200 display_flex overflow_hidden"
									onClick={() => 1}
									onKeyPress={() => 1}
									role="button"
									tabIndex={0}
								>
									{ozonio.image ? (
										<img
											src={ozonio.image.url}
											alt=""
											className="cards_photo big"
										/>
									) : (
										<img src={profileDefaultOzonio} alt="ozonio" />
									)}
									<input
										type="file"
										accept="image/png, image/jpeg"
										onChange={handleFile}
										className="input-file"
									/>
								</div>
								<Typography scale="medium" weight="600" className="m_b_xxs">
									Roles
								</Typography>
								<ul className="m_b_lg p_l_lg m_t_none">
									{(Array.isArray(ozonio.role)
										? ozonio.role
										: [ozonio.role]
									).map((rol: any) => (
										<li>
											<Typography scale="medium" weight="400" className="">
												{rol.description}
											</Typography>
										</li>
									))}
								</ul>
								<Typography scale="medium" weight="600" className="m_b_xxs">
									Número telefónico
								</Typography>
								<Typography scale="medium" weight="400" className="m_b_lg">
									{ozonio.phone}
								</Typography>
								<Typography scale="medium" weight="600" className="m_b_xxs">
									Estado
								</Typography>
								<Typography scale="medium" weight="400" className="m_b_lg">
									{ozonio.isActive ? 'Activo' : 'Inactivo'}
								</Typography>
								<Typography scale="medium" weight="600" className="m_b_xxs">
									Correo electrónico
								</Typography>
								<Typography scale="medium" weight="400" className="m_b_lg">
									{ozonio.username}
								</Typography>
								{ozonio.moonflowId !== undefined && (
									<>
										<Typography scale="medium" weight="600" className="m_b_xxs">
											Id de Moonflow
										</Typography>
										<Typography scale="medium" weight="400" className="m_b_lg">
											{ozonio.moonflowId}
										</Typography>
									</>
								)}
								<RequireRole authRoles={[Roles.USER_MANAGMENT, Roles.ADMIN]}>
									<>
										<Button
											variant="ghost"
											scale="small"
											className="w_100_per"
											onClick={() =>
												restorePassword(ozonio.username)
													.then(() =>
														toasterNotification({
															msg: 'Email de restablecimiento enviado correctamente',
															toasterType: toasterOptions.success,
														}),
													)
													.catch(() =>
														toasterNotification({
															msg: 'No se pudo enviar el email de restablecimiento',
															toasterType: toasterOptions.error,
														}),
													)
											}
										>
											Restaurar Contraseña
										</Button>
										<Button
											variant="outline"
											scale="small"
											icon={<Edit />}
											className="w_100_per m_y_md"
											onClick={() => setOpen(true)}
										>
											Editar
										</Button>
										<Button
											variant="outline"
											scale="small"
											color={ozonio.isActive ? 'red' : 'green'}
											className="w_100_per m_y_md"
											onClick={() => toogleActiveStatus()}
											disabled={loadingActive}
										>
											{ozonio.isActive ? 'In' : 'Re'}activar usuario
										</Button>
									</>
								</RequireRole>
							</div>
						</Grid>

						<Grid item xs={9}>
							<RequireRole authRoles={[Roles.USER_MANAGMENT, Roles.ADMIN]}>
								<>
									<Typography scale="large" weight="600" className="m_b_xxs">
										Documentos de contratación
									</Typography>
									<Grid
										container
										direction="row"
										spacing={1}
										className="m_none w_100_per"
									>
										<LoadDocuments
											documents={ozonio?.documents ?? []}
											onDelete={(file: EvidenceDocument<OzonioDocumentType>) =>
												deleteFiles(file)
											}
											onAdd={handleDocument}
											otherTypeName={OzonioDocumentType.other_license}
											availableDocs={[
												OzonioDocumentType.IMSS,
												OzonioDocumentType.birth_certificate,
												OzonioDocumentType.RFC,
												OzonioDocumentType.ine_front,
												OzonioDocumentType.ine_back,
												OzonioDocumentType.proof_of_address,
												OzonioDocumentType.bank_account,
												OzonioDocumentType.studies_certificate,
												OzonioDocumentType.INFONAVIT,
												OzonioDocumentType.work_references,
												OzonioDocumentType.contract,
											]}
											docsValues={OzonioDocumentTypeValues}
										/>
									</Grid>
									<Typography scale="large" weight="600" className="m_b_xxs">
										Incapacidades y/o Licencias
									</Typography>
									<Grid
										container
										direction="row"
										spacing={1}
										className="m_none w_100_per"
									>
										<LoadDocuments
											documents={ozonio?.documents ?? []}
											onDelete={(file: EvidenceDocument<OzonioDocumentType>) =>
												deleteFiles(file)
											}
											onAdd={handleDocument}
											otherTypeName={OzonioDocumentType.other_medical_leave}
											availableDocs={[]}
											docsValues={OzonioDocumentTypeValues}
										/>
									</Grid>
									<Typography scale="large" weight="600" className="m_b_xxs">
										Notificaciones
									</Typography>
									<Grid
										container
										direction="row"
										spacing={1}
										className="m_none w_100_per"
									>
										<LoadDocuments
											documents={ozonio?.documents ?? []}
											onDelete={(file: EvidenceDocument<OzonioDocumentType>) =>
												deleteFiles(file)
											}
											onAdd={handleDocument}
											otherTypeName={OzonioDocumentType.other_notifications}
											availableDocs={[]}
											docsValues={OzonioDocumentTypeValues}
										/>
									</Grid>
									<Typography scale="large" weight="600" className="m_b_xxs">
										Proceso de selección
									</Typography>
									<Grid
										container
										direction="row"
										spacing={1}
										className="m_none w_100_per"
									>
										<LoadDocuments
											documents={ozonio?.documents ?? []}
											onDelete={(file: EvidenceDocument<OzonioDocumentType>) =>
												deleteFiles(file)
											}
											onAdd={handleDocument}
											otherTypeName={OzonioDocumentType.other_selection_process}
											availableDocs={[
												OzonioDocumentType.CV,
												OzonioDocumentType.enneagram,
												OzonioDocumentType.technical_test,
											]}
											docsValues={OzonioDocumentTypeValues}
										/>
									</Grid>
								</>
							</RequireRole>
						</Grid>
					</Grid>
				</div>
			) : (
				'cargando...'
			)}
			<RequireRole authRoles={[Roles.USER_MANAGMENT, Roles.ADMIN]}>
				<EditOzonio
					open={open}
					setOpen={setOpen}
					values={ozonio}
					setResult={setResult}
				/>
			</RequireRole>
		</div>
	);
}

export default DetailsOzonio;
